<app-icon [icon]="icon"></app-icon>
